import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { ServiceGvariableProvider } from '../../providers/service-gvariable/service-gvariable';
import { B08ReportManagementPage } from '../b08-report-management/b08-report-management';
import { IonicSelectableComponent } from 'ionic-selectable';
/**
 * Generated class for the B08cFleetTransactionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
interface Port {
  id: string;
  name: string;
}
interface branchInfo{
  BRANCH_ID: string;
  BRANCH_NAME: string;
  BRANCH_ACTIVE: string;  
}
interface corpInfo{
  CORP_ID: string;
  CORP_NAME: string;
  CORP_ACTIVE: string;  
}
interface reportInfo{}
@IonicPage()
@Component({
  selector: 'page-b08c-fleet-transaction',
  templateUrl: 'b08c-fleet-transaction.html',
})
export class B08cFleetTransactionPage {
  ports: Port[] = [];
  port: Port;

  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  BRANCH_ID: any = 'All';
  private todo : FormGroup;
  loading: any;
  Status: any;
  corpArr: corpInfo[] = [];
  corpItems: corpInfo[] = [];
  reportItems: reportInfo[] = [];
  public errorMessage: any = "";
  CORP_ID: any = 'All';
  transDateFrom: any;
  transDateTo: any;
  plateNumber: any;
  filename:any;
  selectCORP_ID:any;
  report_request = {
    Report: "3",
    Param: "1",
    Data:{
      CORP_ID: "All",
      BRANCH_ID: "All",
      PLATE: "",
      CARDNO:"",
      START: "",
      END: "",
      SORT: "CORP_NAME",
      SORT_TYPE: "ASC"
    }
  }


  onSelectCorporate(data)
  {
   if(data != "All")
   {
    let val = this.corpItems.find(c => c.CORP_ID === data);
    this.report_request.Data.CORP_ID = val["CORP_ID"];
   
   }
   else
   {
    this.report_request.Data.CORP_ID ="All";
   }
  }  

  onSelectBranch(data)
  {
   if(data != "All")
   {
    let val = this.branchItems.find(c => c.BRANCH_ID === data);
    this.report_request.Data.BRANCH_ID = val["BRANCH_ID"];
   
   }
   else
   {
    this.report_request.Data.BRANCH_ID ="All";
   }
  }  
  mybranchid:any;
  mybranchname:any;
  mycorpid:any;
  mycorpname:any;
  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public serviceapi:ServiceApiProvider,
              public loadingCtrl: LoadingController, public global:ServiceGvariableProvider) {
    this.mybranchid = sessionStorage.getItem('userbranchid');
    this.mycorpid = sessionStorage.getItem('usercorpid');
    this.mycorpname = sessionStorage.getItem('usercorpname');
    console.log(this.mycorpid);
    this.showLoader();
    if(this.mybranchid != "null")
    {
      this.report_request.Data.BRANCH_ID = this.mybranchid;
      let tbl = ["BRANCH"];
      let column = ["BRANCH_ID"];
      let value = [this.mybranchid];
      
      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
    

      this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
        
        this.Status = result["Message"];
      
        if (this.Status == '1'){
          let Records = result["Records"];
          this.mybranchname = Records[0]["BRANCH_NAME"];
        }
        else {
        
        }
      }, (err) => {
      
    
      });        
    } 
    else
    {
      let tbl = ["All"];
      let column = ["All"];
      let value = ["All"];
      
      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
     
      this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
        
        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.branchArr = Records;
          this.branchItems = this.branchArr;
        }
      }, (err) => {
      
    
      });      
    }
    if(this.mycorpid == 'null')
    {
      this.todo = this.formBuilder.group({
        corporate: ['', Validators.required],
        branch: [''],
        plateNumber: [''],
        transdateFrom: [''],
        transdateTo: [''],
      });
    }
    else
    {
      this.todo = this.formBuilder.group({
        corporate: [''],
        branch: [''],
        plateNumber: [''],
        transdateFrom: [''],
        transdateTo: [''],
      });
      this.report_request.Data.CORP_ID = this.mycorpid
    }

    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let sortby= "CORP_NAME";
    let sorttype= "ASC";
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
   
   
    this.serviceapi.readdata(json_data,"CORPORATE","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.corpArr = Records;
        this.corpItems = this.corpArr;
        console.log(this.corpItems);
          //this.ports = [];
          console.log("test");
          let k=0;
          let z = {
            id:"All",
            name:"All"
          };
          (this.ports).push(z);
          for(k=0;k<(this.corpItems).length;k++)
          {

            let z = {
              id:"",
              name:""
            };
            z.id = this.corpItems[k].CORP_ID;
            z.name = this.corpItems[k].CORP_NAME;
            console.log(z);
            (this.ports).push(z);
          }
          console.log(this.ports);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B08cFleetTransactionPage');
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });

    this.loading.present();
  }

  onChangeCorp(data){
    this.CORP_ID = data;
  }

  goTo(){
    this.navCtrl.setRoot(B08ReportManagementPage);
  }

  generate(){
    console.log(this.report_request);
    this.showLoader();

    this.serviceapi.reportrequest(this.report_request).then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.reportItems = Records;
        console.log(this.reportItems)
        let i = 0;
        let total = 0;
        for(i=0;i<this.reportItems.length;i++)
        {
            let val = this.reportItems[i];
            total = total + val['TRANSAMOUNT'];
        }
        console.log("--------")
        console.log(total)
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  download(){
    this.showLoader();
    this.report_request.Param = "2";
    this.serviceapi.reportrequest(this.report_request).then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.reportItems = Records;
        let file = result["File"];
        let path = file.replace('..','');
        let url = this.global.URL+"/api";
        var remove = path.substring(0, path.lastIndexOf("/"));
        console.log(remove);
        var splitTest = file.split('\\').pop().split('/').pop();
        this.filename=url+remove+"/"+splitTest;
        console.log(this.filename);
        window.open(this.filename,"_blank");
        console.log(this.reportItems)
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  cancel(){
    this.navCtrl.pop();
  }

  clearFilter(){
    this.CORP_ID = 'All';
    this.plateNumber = '';
    this.report_request.Data.START = '';
    this.report_request.Data.END = '';
  }
  portChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('port:', event.value);
    let data = event.value["id"];
    if(data != "All")
    {
     let val = this.corpItems.find(c => c.CORP_ID === data);
     this.report_request.Data.CORP_ID = val["CORP_ID"];
    
    }
    else
    {
     this.report_request.Data.CORP_ID ="All";
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/b08c-fleet-transaction/b08c-fleet-transaction.ts